const DailyStockIssues = () => import("./views/DailyStockIssues.vue");

export default [
  {
    path: "/inventory/dailyOutcomes",
    name: "inventory.dailyStockOutcomes",
    component: DailyStockIssues,
    meta: { roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"] },
  },
];
